type MatchesOwnerPetSearchInput = {
  term: string;
  ownerName?: string | null;
  petName?: string | null;
  petRecordNumber?: string | null;
};

const normalizeText = (value?: string | null) => (value ?? "").trim().toLowerCase();
const onlyDigits = (value?: string | null) => (value ?? "").replace(/\D/g, "");

export const matchesOwnerPetSearch = ({
  term,
  ownerName,
  petName,
  petRecordNumber,
}: MatchesOwnerPetSearchInput): boolean => {
  const normalizedTerm = normalizeText(term);
  if (!normalizedTerm) return true;

  const normalizedOwner = normalizeText(ownerName);
  const normalizedPet = normalizeText(petName);
  const normalizedRecordNumber = normalizeText(petRecordNumber);

  if (normalizedOwner.includes(normalizedTerm) || normalizedPet.includes(normalizedTerm)) {
    return true;
  }

  if (!normalizedRecordNumber) {
    return false;
  }

  if (normalizedRecordNumber.includes(normalizedTerm)) {
    return true;
  }

  const termDigits = onlyDigits(normalizedTerm);
  if (!termDigits) {
    return false;
  }

  const recordDigits = onlyDigits(normalizedRecordNumber);
  return recordDigits.includes(termDigits);
};
